import React, { Component } from "react";
import { CallAPI, HandleTextChange, HandleSelectChange, HandleCheckChange, HandlePassChange, Check, GetCookieFunction } from '../../utils/util';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let [searchParams] = useSearchParams();
        return <Component {...props} router={{ location, navigate, searchParams }} />;
    }
    return ComponentWithRouterProp;
}

class EditUser extends Component {
    constructor(props) {
        super(props);
        this.userId = parseInt(this.props.router.searchParams.get('uid'));
        this.state = {
            fName: "", lName: "", gender: "", pNum: "", email: "",
            bDay: "", address1: "", address2: "", city: "", district: "",
            City_District_Id: null,
            type: "", admin: false, active: true, timezone: "Asia/Dhaka",
            pass: "", modalVariant: "", modalMessage: "", loaded: false,
            centers: [], centerID: "",
            citySuggestions: [], showCitySuggestions: false,
            showAddCityModal: false, newLocation: { city: '', district: '' }, addCityModalError: ""
        };
        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSelectChange = HandleSelectChange.bind(this);
        this.handleCheckChange = HandleCheckChange.bind(this);
        this.handlePassChange = HandlePassChange.bind(this);
        this.check = Check.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.selectLocation = this.selectLocation.bind(this);
    }

    componentDidMount() {
        // Load centers list
        CallAPI({}, "centers/list", 'GET', (res) => {
            this.setState({ centers: res || [] });
        });

        CallAPI({}, `users/info/${this.userId}`, 'GET', (res) => {
            // If target user is an executive and current user is not, block access
            const currentUserType = GetCookieFunction("User").type;
            if (res.type === 'executive' && currentUserType !== 'executive') {
                window.location.href = '/forbidden';
                return;
            }

            this.setState({
                fName: res.fName || '',
                lName: res.lName || '',
                email: res.email || '',
                pNum: res.pNum || '',
                bDay: res.bDay ? res.bDay.split('T')[0] : '',
                address1: res.address || '',
                address2: res.address2 || '',
                city: res.city || '',
                district: res.district || '',
                City_District_Id: res.City_District_Id || null,
                gender: res.gender || '',
                type: res.type || '',
                admin: res.admin === 1,
                active: res.active === 1,
                timezone: res.timeZone || 'Asia/Dhaka',
                centerID: res.centerID || '',
                loaded: true
            });
        });
    }

    handleCityChange(e) {
        const value = e.target.value;
        this.setState({ city: value });

        if (value.length >= 2) {
            CallAPI({}, `cityDistricts?search=${encodeURIComponent(value)}`, 'GET', (res) => {
                this.setState({
                    citySuggestions: res.data || [],
                    showCitySuggestions: true
                });
            });
        } else {
            this.setState({ citySuggestions: [], showCitySuggestions: false, district: "", City_District_Id: null });
        }
    }

    selectLocation(location) {
        this.setState({
            City_District_Id: location.id,
            city: location.city,
            district: location.district,
            citySuggestions: [],
            showCitySuggestions: false
        });
    }

    openAddCityModal = () => {
        this.setState({
            showAddCityModal: true,
            showCitySuggestions: false,
            newLocation: { city: this.state.city, district: '' },
            addCityModalError: ''
        });
    }

    closeAddCityModal = () => {
        this.setState({ showAddCityModal: false, addCityModalError: '' });
    }

    handleNewLocationChange = (e) => {
        const { name, value } = e.target;
        this.setState(prev => ({
            newLocation: { ...prev.newLocation, [name]: value }
        }));
    }

    saveNewLocation = (e) => {
        e.preventDefault();
        const { city, district } = this.state.newLocation;

        CallAPI({ city, district }, 'cityDistricts', 'POST', (res) => {
            if (res.success) {
                this.setState({
                    showAddCityModal: false,
                    addCityModalError: '',
                    City_District_Id: res.data.id,
                    city: res.data.city,
                    district: res.data.district
                });
            } else {
                this.setState({ addCityModalError: res.message || "This city/district already exists" });
            }
        }, () => {
            this.setState({ addCityModalError: "Failed to save. Please try again." });
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const payload = {
            userId: this.userId,
            fName: this.state.fName,
            lName: this.state.lName,
            gender: this.state.gender,
            email: this.state.email,
            pNum: this.state.pNum,
            bDay: this.state.bDay || null,
            address1: this.state.address1,
            address2: this.state.address2,
            City_District_Id: this.state.City_District_Id,
            type: this.state.type,
            admin: (this.state.type === 'centeradmin' || this.state.type === 'executive') ? null : this.state.admin,
            active: this.state.active,
            timezone: this.state.timezone,
            pass: this.state.pass || '',
            centerID: this.state.type === 'executive' ? null : (this.state.centerID || null)
        };

        CallAPI(payload, 'users/update', 'PUT', (res) => {
            if (res && res.length > 0 && res[0].success) {
                this.setState({ modalVariant: "success", modalMessage: "User updated successfully." });
            } else {
                this.setState({ modalVariant: "danger", modalMessage: "Failed to update user." });
            }
        }, () => {
            this.setState({ modalVariant: "danger", modalMessage: "Failed to update user." });
        });
    }

    render = () => {
        if (!this.state.loaded) {
            return <div className="ci-page"><p>Loading...</p></div>;
        }

        return (
            <div className="ci-page">
                <div className="ci-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                        <h2>Update Staff Account: {this.state.fName} {this.state.lName}</h2>
                        <p>Update staff account information</p>
                    </div>
                    <a href="/admin/users/lookup" className="action-btn" data-tooltip="Back to Staff List" aria-label="Back to Staff List">
                        <img src={require("../../resources/back.png")} alt="Back" />
                    </a>
                </div>

                {this.state.modalVariant && (
                    <Alert variant={this.state.modalVariant} className="ci-alert">{this.state.modalMessage}</Alert>
                )}

                <form onSubmit={(e) => this.handleSubmit(e)}>
                    <div className="ci-section-title">Personal Details</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="fName">First Name</label>
                                <input type="text" id="fName" name="fName" maxLength="32"
                                    value={this.state.fName}
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="lName">Last Name</label>
                                <input type="text" id="lName" name="lName" maxLength="32"
                                    value={this.state.lName}
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="gender">Gender</label>
                                <select id="gender" name="gender"
                                    value={this.state.gender}
                                    onChange={(e) => this.handleSelectChange(e)}>
                                    <option value="">-- No change --</option>
                                    <option value="MALE">Male</option>
                                    <option value="FEMALE">Female</option>
                                    <option value="OTHER">Other</option>
                                </select>
                            </div>
                            <div className="ci-field">
                                <label htmlFor="bDay">Date of Birth</label>
                                <input type="date" id="bDay" name="bDay"
                                    value={this.state.bDay}
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="timezone">Time Zone</label>
                                <select id="timezone" name="timezone"
                                    value={this.state.timezone}
                                    onChange={(e) => this.handleSelectChange(e)}>
                                    <option value="Asia/Dhaka">Asia/Dhaka</option>
                                    <option value="America/Los_Angeles">America/Los Angeles</option>
                                    <option value="America/Phoenix">America/Phoenix</option>
                                    <option value="America/Denver">America/Denver</option>
                                    <option value="America/New_York">America/New York</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="ci-section-title">Contact & Address</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="pNum">Phone Number</label>
                                <input type="tel" id="pNum" name="pNum" maxLength="20"
                                    value={this.state.pNum}
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="email">Email</label>
                                <input type="email" id="email" name="email"
                                    value={this.state.email}
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="address1">Address</label>
                                <input type="text" id="address1" name="address1" maxLength="100"
                                    value={this.state.address1}
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field ci-field-autocomplete">
                                <label htmlFor="city">City</label>
                                <input type="text" id="city" name="city" maxLength="32"
                                    autoComplete="off"
                                    value={this.state.city}
                                    onChange={(e) => this.handleCityChange(e)}
                                    onBlur={() => setTimeout(() => this.setState({ showCitySuggestions: false }), 200)} />
                                {this.state.showCitySuggestions && (
                                    <ul className="ci-autocomplete-list">
                                        {this.state.citySuggestions.length > 0 ? (
                                            this.state.citySuggestions.map((loc) => (
                                                <li key={loc.id} className="ci-autocomplete-item"
                                                    onMouseDown={() => this.selectLocation(loc)}>
                                                    {loc.city} — {loc.district}
                                                </li>
                                            ))
                                        ) : (
                                            <li className="ci-autocomplete-item ci-autocomplete-add"
                                                onMouseDown={this.openAddCityModal}>
                                                + Add new city/district
                                            </li>
                                        )}
                                    </ul>
                                )}
                            </div>
                            <div className="ci-field">
                                <label htmlFor="district">District</label>
                                <input type="text" id="district" name="district" maxLength="32"
                                    value={this.state.district}
                                    readOnly />
                            </div>
                        </div>
                    </div>

                    <div className="ci-section-title">Role & Access</div>
                    <div className="ci-card">
                        <div className="ci-grid ci-grid-2">
                            <div className="ci-field">
                                <label htmlFor="type">User Type</label>
                                <select id="type" name="type"
                                    value={this.state.type}
                                    onChange={(e) => this.handleSelectChange(e)}>
                                    <option value="">-- No change --</option>
                                    <option value="doctor">Doctor</option>
                                    <option value="nurse">Nurse</option>
                                    <option value="centeradmin">Center Admin</option>
                                    {GetCookieFunction("User").type === 'executive' && (
                                        <option value="executive">Executive</option>
                                    )}
                                </select>
                            </div>
                            {this.state.type !== 'executive' && (
                                <div className="ci-field">
                                    <label htmlFor="centerID">Assigned Center</label>
                                    <select id="centerID" name="centerID"
                                        value={this.state.centerID}
                                        disabled={GetCookieFunction("User").type !== 'executive'}
                                        style={{ opacity: GetCookieFunction("User").type !== 'executive' ? 0.6 : 1 }}
                                        onChange={(e) => this.handleSelectChange(e)}>
                                        <option value="">-- No change --</option>
                                        {this.state.centers.map(c => (
                                            <option key={c.centerID} value={c.centerID}>{c.centerName}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className="ci-field" style={{ justifyContent: 'flex-end' }}>
                                <label className="ci-checkbox-label" style={{ paddingTop: '8px', opacity: (this.state.type === 'centeradmin' || this.state.type === 'executive') ? 0.5 : 1 }}>
                                    <input type="checkbox" name="admin"
                                        checked={this.state.type !== 'centeradmin' && this.state.type !== 'executive' && this.state.admin}
                                        disabled={this.state.type === 'centeradmin' || this.state.type === 'executive'}
                                        onChange={(e) => this.handleCheckChange(e)} />
                                    <span>Admin privileges</span>
                                </label>
                                <label className="ci-checkbox-label" style={{ paddingTop: '8px' }}>
                                    <input type="checkbox" name="active"
                                        checked={this.state.active}
                                        onChange={(e) => this.handleCheckChange(e)} />
                                    <span>Account active</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="ci-section-title">Reset Password (optional)</div>
                    <div className="ci-card">
                        <div className="ci-grid ci-grid-2">
                            <div className="ci-field">
                                <label htmlFor="pass">New Password</label>
                                <input type="password" id="pass" name="pass"
                                    placeholder="Leave blank to keep current"
                                    onChange={(e) => this.handlePassChange(e, this)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="confirmPass">Confirm Password</label>
                                <input type="password" id="confirmPass" name="confirmPass"
                                    placeholder="Confirm new password"
                                    onChange={(e) => this.check(e, this)} />
                            </div>
                        </div>
                    </div>

                    <div className="ci-submit-row">
                        <button type="submit" className="logSubmit ci-submit-btn">Save Changes</button>
                    </div>
                </form>

                {/* ── Add City/District Modal ── */}
                {this.state.showAddCityModal && (
                    <div className="ci-modal-overlay" onClick={this.closeAddCityModal}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>Add New City/District</h3>
                            {this.state.addCityModalError ? (
                                <div>
                                    <p className="ci-modal-error">{this.state.addCityModalError}</p>
                                    <div className="ci-submit-row">
                                        <button type="button" className="ci-modal-icon-btn ci-modal-cancel" onClick={this.closeAddCityModal} title="Close">✕</button>
                                    </div>
                                </div>
                            ) : (
                                <form onSubmit={this.saveNewLocation}>
                                    <div className="ci-field">
                                        <label>City</label>
                                        <input type="text" name="city" required maxLength="45"
                                            value={this.state.newLocation.city}
                                            onChange={this.handleNewLocationChange} />
                                    </div>
                                    <div className="ci-field">
                                        <label>District</label>
                                        <input type="text" name="district" required maxLength="45"
                                            value={this.state.newLocation.district}
                                            onChange={this.handleNewLocationChange} />
                                    </div>
                                    <div className="ci-submit-row">
                                        <button type="button" className="ci-modal-icon-btn ci-modal-cancel" onClick={this.closeAddCityModal} title="Cancel">✕</button>
                                        <button type="submit" className="ci-modal-icon-btn ci-modal-save" title="Save">✓</button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    };
}

export default withRouter(EditUser);
